import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to trigger the lead export using a temporary form.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedLeadIds: { type: Array, default: [] },
    }
  }

  submit() {
    TempFormHelper.create("/lead/export", "post", (form) => {
      if (this.selectedLeadIdsValue.length > 0) {
        this.selectedLeadIdsValue.forEach(leadId => { TempFormHelper.addHiddenInput(form, "lead_ids[]", leadId) })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => { TempFormHelper.addHiddenInput(form, key, value) })
      }
    }).submit() // requestSubmit does not trigger the download
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets.map(dataSet => dataSet.leadId || dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
